import { render, staticRenderFns } from "./PlayCurrentRecording.vue?vue&type=template&id=1822767b&"
import script from "./PlayCurrentRecording.vue?vue&type=script&lang=ts&"
export * from "./PlayCurrentRecording.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports